import { AuthWrapper } from '@/app/components/AuthWrapper/AuthWrapper'
import { MatrixIntent, OnboardingType } from '@/app/const'
import { MatrixPage } from '@/app/pages/MatrixPage/MatrixPage'
import type { FunctionalComponent } from 'preact'
import { useMemo } from 'preact/hooks'
import { useSearchParams } from 'wouter-preact'

export const MatrixCalcPage: FunctionalComponent = () => {
  const [search] = useSearchParams()
  const intent = search.get('intent')

  const type = useMemo(() => {
    switch (intent) {
      case MatrixIntent.Money:
        return OnboardingType.MatrixMoney
      case MatrixIntent.Love:
        return OnboardingType.MatrixLove
      case MatrixIntent.Karma:
        return OnboardingType.MatrixKarma
      default:
        return OnboardingType.Matrix
    }
  }, [intent])

  return (
    <AuthWrapper
      type={type}
    >
      <MatrixPage />
    </AuthWrapper>
  )
}
